import Swal from 'sweetalert2';

export const OBJECT_REMOVAL_PROMPTS = {
  FAST: 'REMOVE_OBJECT_IN_FRONT_OF_SUBJECT',
  ACCURATE: 'REMOVE_OBJECT_IN_FRONT_OF_SUBJECT_ACCURATE',
};

const OBJECT_REMOVAL_MODE_KEYS = {
  FAST: 'fast',
  ACCURATE: 'accurate',
};

const OBJECT_REMOVAL_OPTIONS = [
  {
    key: OBJECT_REMOVAL_MODE_KEYS.FAST,
    prompt: OBJECT_REMOVAL_PROMPTS.FAST,
    label: 'Modalità rapida',
    badgeLabel: 'Più rapida',
    badgeClass: 'object-removal-badge--fast',
    description:
      'Ideale per oggetti piccoli o casi semplici. Arriva prima, ma può essere meno precisa se gli oggetti coprono volto, mani o dettagli importanti.',
    estimatedTimeLabel: 'Attesa media: 15 secondi',
    loaderDurationMs: 15000,
    creditLabel: '1 credito AI',
    default: true,
  },
  {
    key: OBJECT_REMOVAL_MODE_KEYS.ACCURATE,
    prompt: OBJECT_REMOVAL_PROMPTS.ACCURATE,
    label: 'Modalità accurata',
    badgeLabel: 'Più precisa',
    badgeClass: 'object-removal-badge--accurate',
    description:
      'Lavora meglio sulle ricostruzioni difficili e sui dettagli coperti. Richiede più attesa, ma tende a produrre un risultato più curato.',
    estimatedTimeLabel: 'Attesa media: 1 minuto',
    loaderDurationMs: 60000,
    creditLabel: '1 credito AI',
  },
];

const DEFAULT_OBJECT_REMOVAL_OPTION =
  OBJECT_REMOVAL_OPTIONS.find((option) => option.default) ||
  OBJECT_REMOVAL_OPTIONS[0];

const renderObjectRemovalOptionCard = (option) => `
  <label class="bg-fusion-option">
    <input
      type="radio"
      name="object-removal-mode"
      value="${option.key}"
      ${option.default ? 'checked' : ''}
    />
    <span class="bg-fusion-radio-dot" aria-hidden="true"></span>
    <span class="bg-fusion-option-content">
      <span class="bg-fusion-option-header">
        <span class="bg-fusion-option-title">${option.label}</span>
        <span class="bg-fusion-badge object-removal-badge ${option.badgeClass}">
          ${option.badgeLabel}
        </span>
      </span>
      <span class="bg-fusion-option-desc">${option.description}</span>
      <span class="bg-fusion-option-meta">
        <strong>${option.estimatedTimeLabel}</strong> · ${option.creditLabel}
      </span>
    </span>
  </label>
`;

const getObjectRemovalOption = (optionKey) =>
  OBJECT_REMOVAL_OPTIONS.find((option) => option.key === optionKey) ||
  DEFAULT_OBJECT_REMOVAL_OPTION;

export const chooseObjectRemovalMode = async () => {
  const result = await Swal.fire({
    title: 'Rimuovi gli oggetti',
    html: `
      <div class="bg-fusion-choice">
        <p class="bg-fusion-subtitle">
          Scegli se privilegiare rapidità o precisione. Il costo è lo stesso.
        </p>
        <div
          class="bg-fusion-options"
          role="radiogroup"
          aria-label="Modalità di rimozione oggetti"
        >
          ${OBJECT_REMOVAL_OPTIONS.map(renderObjectRemovalOptionCard).join('')}
        </div>
      </div>
    `,
    showCancelButton: true,
    confirmButtonText: '✨ Continua',
    cancelButtonText: 'Annulla',
    confirmButtonColor: '#278e8e',
    preConfirm: () =>
      Swal.getPopup().querySelector('input[name="object-removal-mode"]:checked')
        ?.value,
  });

  if (!result.isConfirmed) {
    return null;
  }

  return getObjectRemovalOption(result.value);
};
